export enum ButtonThemes {
    Primary = 'primary',
    Secondary = 'secondary',
    SecondaryLight = 'secondaryLight',
    Red = 'red',
    RedSecondary = 'redSecondary',
    Green = 'green',
    GreenSecondary = 'greenSecondary',
}
